//messages.js
export default {
    techhelp: "Technical Help",
};
